export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Animated Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 animate-gradient" style={{ backgroundSize: '400% 400%' }}></div>
      
      {/* Parallax Background Image */}
      <div 
        className="absolute inset-0 w-full h-full opacity-30"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=modern%20technology%20office%20workspace%20with%20multiple%20computer%20monitors%20displaying%20data%20analytics%20dashboards%20traffic%20management%20system%20interface%20dark%20moody%20atmosphere%20with%20golden%20amber%20accent%20lighting%20professional%20corporate%20environment%20abstract%20digital%20network%20connections%20floating%20in%20air&width=1920&height=1080&seq=hero-parallax-bg-001&orientation=landscape)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      />
      
      {/* Animated Mesh Gradient */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-yellow-500/10 rounded-full blur-3xl animate-blob"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-amber-500/10 rounded-full blur-3xl animate-blob" style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-orange-500/5 rounded-full blur-3xl animate-blob" style={{ animationDelay: '4s' }}></div>
      </div>

      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'linear-gradient(rgba(251, 191, 36, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(251, 191, 36, 0.1) 1px, transparent 1px)',
        backgroundSize: '40px 40px md:60px md:60px'
      }}></div>

      {/* Floating Icons - Hidden on Mobile */}
      <div className="hidden md:flex absolute top-32 left-1/4 w-16 h-16 bg-yellow-500/20 rounded-2xl items-center justify-center animate-float backdrop-blur-sm border border-yellow-500/30 shadow-lg shadow-yellow-500/20">
        <i className="ri-line-chart-line text-yellow-400 text-3xl"></i>
      </div>
      <div className="hidden md:flex absolute top-48 right-1/3 w-14 h-14 bg-white/10 rounded-xl items-center justify-center animate-float-delayed backdrop-blur-sm border border-white/20">
        <i className="ri-file-text-line text-white/80 text-2xl"></i>
      </div>
      <div className="hidden md:flex absolute bottom-40 right-1/4 w-12 h-12 bg-yellow-500/15 rounded-lg items-center justify-center animate-float backdrop-blur-sm border border-yellow-500/30">
        <i className="ri-notification-3-line text-yellow-400 text-xl"></i>
      </div>
      <div className="hidden md:flex absolute top-1/3 right-20 w-16 h-16 bg-white/10 rounded-2xl items-center justify-center animate-float-delayed backdrop-blur-sm border border-white/20">
        <i className="ri-robot-line text-white/80 text-3xl"></i>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-32 w-full">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Left Content */}
          <div className="scroll-animate text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-yellow-500/20 rounded-full mb-4 md:mb-6 backdrop-blur-sm border border-yellow-500/30 animate-pulse-glow">
              <div className="w-1.5 md:w-2 h-1.5 md:h-2 bg-yellow-400 rounded-full animate-pulse"></div>
              <span className="text-xs md:text-sm font-semibold text-yellow-400">Plataforma Inteligente</span>
            </div>
            
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-3 md:mb-4 leading-tight">
              Gestão Inteligente de{' '}
              <span className="bg-gradient-to-r from-yellow-400 via-amber-400 to-orange-400 bg-clip-text text-transparent">
                Multas de Trânsito
              </span>
            </h1>
            
            <p className="text-xl md:text-2xl lg:text-3xl text-yellow-400 font-serif italic mb-5 md:mb-7">
              Automatize, Escale e Lucre Mais
            </p>
            
            <div className="bg-gray-900/60 backdrop-blur-md rounded-2xl p-5 md:p-6 border border-gray-700/50 mb-6 md:mb-8">
              <div className="space-y-5 md:space-y-6">
                <p className="text-base md:text-lg lg:text-xl text-gray-200 max-w-xl mx-auto lg:mx-0 leading-relaxed">
                  A Central da Multa é uma plataforma completa voltada para empresas especializadas em recursos de multas. Nosso propósito é impulsionar o crescimento do seu negócio, oferecendo novas oportunidades e simplificando sua rotina com ferramentas de gestão de clientes, organização de documentos e geração automatizada de recursos.
                </p>
                
                <p className="text-base md:text-lg lg:text-xl text-gray-200 max-w-xl mx-auto lg:mx-0 leading-relaxed">
                  Além disso, automatizamos as notificações para acompanhamento eficiente dos prazos para que você aproveite ao máximo as oportunidades provenientes dos editais enriquecidos, da indicação de leads orgânicos, da recorrência gerada pelo rastreamento de multas e também do atendimento a frotistas.
                </p>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center lg:justify-start">
              <a
                href="https://app.centraldamulta.app.br/register"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-yellow-500 to-amber-500 text-gray-900 rounded-full text-sm md:text-lg font-semibold transition-all duration-300 flex items-center justify-center gap-2 md:gap-3 whitespace-nowrap cursor-pointer shadow-lg shadow-yellow-500/30 hover:shadow-xl hover:shadow-yellow-500/50 hover:scale-105 overflow-hidden"
              >
                <span className="relative z-10">Cadastre-se Grátis</span>
                <div className="relative z-10 w-6 md:w-8 h-6 md:h-8 bg-gray-900 rounded-full flex items-center justify-center group-hover:bg-gray-800 transition-colors">
                  <i className="ri-arrow-right-line text-yellow-400 text-sm md:text-lg group-hover:translate-x-1 transition-transform"></i>
                </div>
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent group-hover:left-[100%] transition-all duration-700"></div>
              </a>
              
              <button
                onClick={() => document.getElementById('servicos-detalhados')?.scrollIntoView({ behavior: 'smooth' })}
                className="relative px-6 md:px-8 py-3 md:py-4 bg-white/5 text-white rounded-full text-sm md:text-lg font-semibold hover:bg-white/10 transition-all duration-300 border border-white/20 hover:border-white/40 whitespace-nowrap cursor-pointer backdrop-blur-sm group overflow-hidden"
              >
                <span className="relative z-10">Conhecer Funcionalidades</span>
                <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/10 to-amber-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </button>
            </div>
          </div>

          {/* Right Dashboard Preview - Hidden on Mobile, Simplified on Tablet */}
          <div className="relative scroll-animate-right hidden md:block">
            {/* Main Dashboard Card */}
            <div className="relative bg-gray-800/50 backdrop-blur-xl rounded-2xl md:rounded-3xl shadow-2xl p-4 md:p-8 border border-gray-700/50 overflow-hidden group hover:border-yellow-500/30 transition-all duration-500">
              {/* Glassmorphism Shine Effect */}
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-transparent pointer-events-none"></div>
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-yellow-400/50 to-transparent"></div>
              
              {/* Header */}
              <div className="flex items-center justify-between mb-4 md:mb-8 relative z-10">
                <div>
                  <h3 className="text-lg md:text-2xl font-bold text-white">Dashboard</h3>
                  <p className="text-xs md:text-sm text-gray-400">Visão geral do sistema</p>
                </div>
                <div className="w-10 md:w-12 h-10 md:h-12 bg-gradient-to-br from-yellow-400 via-yellow-500 to-amber-600 rounded-lg md:rounded-xl flex items-center justify-center shadow-lg shadow-yellow-500/30 relative overflow-hidden group-hover:scale-110 transition-transform duration-300">
                  <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/30 to-transparent"></div>
                  <i className="ri-dashboard-line text-gray-900 text-xl md:text-2xl relative z-10"></i>
                </div>
              </div>

              {/* Stats Grid */}
              <div className="grid grid-cols-2 gap-2 md:gap-4 mb-4 md:mb-6 relative z-10">
                {[
                  { icon: 'ri-user-line', value: '247', label: 'Clientes Ativos', highlight: true },
                  { icon: 'ri-car-line', value: '1.8K', label: 'Veículos', highlight: false },
                  { icon: 'ri-file-list-line', value: '523', label: 'Recursos Ativos', highlight: false },
                  { icon: 'ri-money-dollar-circle-line', value: '89%', label: 'Taxa Sucesso', highlight: true },
                ].map((stat, index) => (
                  <div 
                    key={index}
                    className={`rounded-xl md:rounded-2xl p-3 md:p-5 border backdrop-blur-sm relative overflow-hidden group/stat transition-all duration-300 hover:scale-105 ${
                      stat.highlight 
                        ? 'bg-gradient-to-br from-yellow-500/20 via-yellow-600/10 to-amber-500/5 border-yellow-500/30 hover:border-yellow-400/50' 
                        : 'bg-gradient-to-br from-gray-700/50 via-gray-800/30 to-gray-700/20 border-gray-600/30 hover:border-gray-500/50'
                    }`}
                  >
                    <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-transparent opacity-0 group-hover/stat:opacity-100 transition-opacity"></div>
                    <div className="flex items-center gap-2 md:gap-3 mb-1 md:mb-2 relative z-10">
                      <div className={`w-8 md:w-10 h-8 md:h-10 rounded-lg flex items-center justify-center shadow-lg ${
                        stat.highlight 
                          ? 'bg-gradient-to-br from-yellow-400 via-yellow-500 to-amber-600 shadow-yellow-500/40' 
                          : 'bg-gradient-to-br from-gray-300 via-gray-400 to-gray-500 shadow-gray-500/30'
                      }`}>
                        <i className={`${stat.icon} text-gray-900 text-base md:text-xl`}></i>
                      </div>
                      <div>
                        <p className="text-xl md:text-3xl font-bold text-white">{stat.value}</p>
                        <p className="text-[10px] md:text-xs text-gray-400">{stat.label}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Mini Chart */}
              <div className="bg-gray-900/50 rounded-xl md:rounded-2xl p-3 md:p-5 border border-gray-700/50 relative z-10 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/3 to-transparent"></div>
                <div className="flex items-center justify-between mb-2 md:mb-3 relative z-10">
                  <p className="text-xs md:text-sm font-semibold text-gray-300">Recursos Gerenciados</p>
                  <span className="text-[10px] md:text-xs font-semibold flex items-center gap-1 px-1.5 md:px-2 py-0.5 md:py-1 bg-green-500/20 text-green-400 rounded-full border border-green-500/30">
                    <i className="ri-arrow-up-line"></i>
                    +24%
                  </span>
                </div>
                <div className="flex items-end gap-1 md:gap-2 h-14 md:h-20 relative z-10">
                  {[40, 55, 70, 85, 100].map((height, index) => (
                    <div 
                      key={index}
                      className={`flex-1 rounded-t-lg shadow-inner transition-all duration-300 hover:opacity-80 ${
                        index < 2 
                          ? 'bg-gradient-to-t from-gray-600 to-gray-500' 
                          : 'bg-gradient-to-t from-yellow-600 via-yellow-500 to-yellow-400 shadow-lg shadow-yellow-500/30'
                      }`}
                      style={{ height: `${height}%` }}
                    >
                      {index === 4 && (
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer"></div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Decorative Corner Accents */}
              <div className="absolute top-4 right-4 w-12 md:w-20 h-12 md:h-20 border-t-2 border-r-2 border-yellow-500/20 rounded-tr-2xl md:rounded-tr-3xl pointer-events-none group-hover:border-yellow-500/40 transition-colors duration-300"></div>
              <div className="absolute bottom-4 left-4 w-12 md:w-20 h-12 md:h-20 border-b-2 border-l-2 border-yellow-500/20 rounded-bl-2xl md:rounded-bl-3xl pointer-events-none group-hover:border-yellow-500/40 transition-colors duration-300"></div>
            </div>

            {/* Floating Notification Card */}
            <div className="absolute -bottom-4 md:-bottom-6 -left-2 md:-left-6 bg-gray-800/90 backdrop-blur-xl rounded-xl md:rounded-2xl shadow-xl p-3 md:p-4 border border-gray-700/50 max-w-[180px] md:max-w-xs overflow-hidden animate-bounce-subtle">
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-transparent pointer-events-none"></div>
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-green-400/50 to-transparent"></div>
              <div className="flex items-center gap-2 md:gap-3 relative z-10">
                <div className="w-8 md:w-10 h-8 md:h-10 bg-gradient-to-br from-green-400 via-green-500 to-emerald-600 rounded-full flex items-center justify-center shadow-lg shadow-green-500/40">
                  <i className="ri-check-line text-white text-base md:text-xl"></i>
                </div>
                <div>
                  <p className="text-xs md:text-sm font-semibold text-white">Recurso Aprovado</p>
                  <p className="text-[10px] md:text-xs text-gray-400">Cliente: João Silva</p>
                </div>
              </div>
            </div>

            {/* Floating AI Badge */}
            <div className="absolute -top-2 md:-top-4 -right-2 md:-right-4 bg-gradient-to-br from-yellow-400 via-yellow-500 to-amber-600 rounded-xl md:rounded-2xl shadow-xl p-2 md:p-4 border-2 md:border-4 border-gray-900/50 overflow-hidden animate-pulse-glow">
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/40 to-transparent pointer-events-none"></div>
              <div className="flex items-center gap-1 md:gap-2 relative z-10">
                <i className="ri-robot-2-line text-gray-900 text-lg md:text-2xl"></i>
                <div>
                  <p className="text-[10px] md:text-xs font-bold text-gray-900">IA Ativa</p>
                  <p className="text-[8px] md:text-xs text-gray-800/80">Automação 24/7</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
